import store from "@/store";

export default {
  install(Vue) {
    Vue.directive('permission', async function (el, binding) {
      let buttons = store.getters.buttons
      let isShow = _.find(buttons, {
        englishName: binding.value
      })
      let attr = isShow ? 'inline-block' : 'none'
      el.style.display = attr
    })
  }
}



// WEBPACK FOOTER //
// ./src/directive/v-permission.js